export enum ErrorCodes {
  NotSupplied = 0,
  BadlyFormed = 400,
  NotAuthorized = 401,
  NotFound = 404,
  Forbidden = 403,
  MethodNotAllowed = 405,
  Unprocessable = 422,
  ServiceUnavailable = 503,
}
